import React from 'react';
import { testimonials } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function ParentFeedback() {
  return <section className="bg-dusty-wash py-14 lg:py-24" data-id="element-148" data-mp="34ke8uu812zhq">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-149" data-mp="2qm7jk2h5a7to">
        <SectionHeading title="What Parents Say Changed First" data-id="element-150" data-mp="2qnr07u6pqkvz" />

        <ul className="mt-10 grid gap-4 md:grid-cols-3 lg:mt-12 lg:gap-6" data-id="element-151" data-mp="2vj6g0roa6qv1">
          {testimonials.map(t => <li key={t.headline} data-id="element-152" data-mp="2gua8cvq4zfuy">
              <figure className="flex h-full flex-col rounded-3xl bg-paper p-6 sm:p-8" data-id="element-153" data-mp="2lm1o0b7r816b">
                <span className="font-display text-[48px] leading-[0.6] text-terra" aria-hidden="true" data-id="element-154" data-mp="27uww5vamod6j">
                  “
                </span>
                <h3 className="mt-3 font-display text-[23px] leading-tight text-ink" data-id="element-155" data-mp="2bxjoryf4i24s">“{t.headline}”</h3>
                <blockquote className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-156" data-mp="1xy1wva6j68r7">{t.body}</blockquote>
              </figure>
            </li>)}
        </ul>

        <p className="mt-6 text-center text-[13px] text-ink-mute" data-id="element-157" data-mp="ghkd3pg6o84b">Illustrative sample feedback shown for preview purposes.</p>
      </div>
    </section>;
}